export const SET_VEHICLE_DESCRIPTION = 'SET_VEHICLE_DESCRIPTION';
export const SET_VEHICLE_CODE = 'SET_VEHICLE_CODE';
export const SET_CONTRACT_START_DATE = 'SET_CONTRACT_START_DATE';

export function setVehicleCode(asosCode) {
  return {
    type: SET_VEHICLE_CODE,
    payload: asosCode
  };
}

export function setVehicleDescription(asosDescription) {
  return {
    type: SET_VEHICLE_DESCRIPTION,
    payload: asosDescription
  };
}

export function setContractStartDate(contractStartDate) {
  return {
    type: SET_CONTRACT_START_DATE,
    payload: contractStartDate
  };
}

export function getVehicleCode(store) {
  return store.asos.asosCode;
}

export function getVehicleDescription(store) {
  return store.asos.asosDescription;
}

const initialState = {
  vehicleDescription: '',
  vehicleCode: '',
  contractStartDate: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_VEHICLE_DESCRIPTION:
      return {
        ...state,
        vehicleDescription: action.payload
      };
    case SET_VEHICLE_CODE:
      return {
        ...state,
        vehicleCode: action.payload
      };
    case SET_CONTRACT_START_DATE:
      return {
        ...state,
        contractStartDate: action.payload
      };
    default:
      return state;
  }
}
